import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { uuid4 } from '../../libs/uuid4';
import { getAsync } from '../helper/axiosHelper';
import { addMenuTitle } from '../../features/MainMenuTitleSlice';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const MainMenu = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [data, setData] = useState([]);
  const [isLogin, setIsLogin] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();


  useEffect(() => {
    (async () => {
      const response = await getAsync('CMSMenu/GetCMSMenus');
      setData(response?.data);
    })();
  }, []);

  // Create a new array with updated objects value with login
  const updatedArrayOfObjects = data?.map(function (object) {
    return object?.childrens;
  });
  const updatedArray = updatedArrayOfObjects?.flatMap(function (object) {
    return object;
  });

  const update = updatedArray?.map(function (object) {
    const titleobj = {
      menuItemID: object?.shjcApiID,
      ar_SA: object?.ar_SA,
      en_US: object?.en_US,
    };
    return titleobj;
  });
  // dispatch(addMenuTitle(update));

  useEffect(() => {
    if (update?.length) {
      dispatch(addMenuTitle(update));
    }
  }, [update, dispatch]);

  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const toggleSubmenu = () => {
    setIsSubmenuOpen(true);

    setTimeout(() => {
      setIsSubmenuOpen(false);
    }, 300);
  };

  return (
    <>
      <div className="flex min-[1368px]:space-x-20  space-x-7 lg:flex-row  flex-col">
        {!isLogin && (
          <>
            {data?.map((items) => (
              <li key={uuid4()} className="dropdown text-customgreen ms-2 text-lg  cursor-pointer">
                {t(`${isActive ? items?.ar_SA : items?.en_US.charAt(0).toUpperCase() + items?.en_US.slice(1)} `)}
                <KeyboardArrowDownIcon />

                <ul className={` dropdown_menu`}>
                  {items?.childrens?.map((childItem, childIndex) => (
                    <Link
                      to={`${childItem?.pageLink}/${childItem?.shjcApiID}`}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                      key={uuid4()}
                    >
                      <li
                        className={` dropdown_item-${childIndex + 1} ${isSubmenuOpen && 'closed'} space_align`}
                        onClick={toggleSubmenu}
                      >
                        {t(
                          `${isActive ? childItem?.ar_SA : childItem?.en_US.charAt(0).toUpperCase() + childItem?.en_US.slice(1)}`,
                        )}
                      </li>
                      <hr className="text-gray-400" />
                    </Link>
                  ))}
                </ul>
              </li>
              //   <li
              //     key={uuid4()}
              //     className="text-customgreen ms-2 text-lg list-none hover:border-b-4  hover:border-customgreen
              //  transition duration-300 ease-in-out border-transparent border-b-4  pb-2"
              //   >
              //     <Dropdown
              //       label={t(`${isActive ? items?.ar_SA : items?.en_US.charAt(0).toUpperCase() + items?.en_US.slice(1)}`)}
              //       inline
              //       className="capitalize"
              //     >
              //       {items?.childrens?.map((childItem, childIndex) => (

              //         <Dropdown.Item className="group hover:text-customgreen flex  flex-col  " key={childIndex}>

              //           <Link
              //             className="group-hover:text-customgreen"
              //             to={`${childItem?.pageLink}/${childItem?.menuItemID}`}
              //           >
              //             {t(
              //               `${isActive ? childItem?.ar_SA : childItem?.en_US.charAt(0).toUpperCase() + childItem?.en_US.slice(1)}`,
              //             )}
              //           </Link>

              //         </Dropdown.Item>
              //       ))}
              //     </Dropdown>
              //   </li>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default React.memo(MainMenu);
